import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import apiKey from "../config/apiKey";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "cabil_lang",
      caches: ["localStorage"],
    },
  });

// Admin-editable copy: bundled en.json/ar.json above are the build-time
// defaults; any key an admin has edited via the Translations page lives in
// the DB and gets layered on top here so edits go live without a rebuild.
function setAtPath(obj, dotPath, value) {
  const parts = dotPath.split(".");
  let node = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    node = node[parts[i]] = node[parts[i]] || {};
  }
  node[parts[parts.length - 1]] = value;
}

axios
  .get(`${apiKey}/api/edolutions/translation-overrides`)
  .then(({ data }) => {
    const rows = data?.data || [];
    if (!rows.length) return;
    const enOverrides = {};
    const arOverrides = {};
    rows.forEach((row) => {
      if (row.en != null) setAtPath(enOverrides, row.key, row.en);
      if (row.ar != null) setAtPath(arOverrides, row.key, row.ar);
    });
    i18n.addResourceBundle("en", "translation", enOverrides, true, true);
    i18n.addResourceBundle("ar", "translation", arOverrides, true, true);
    i18n.emit("languageChanged", i18n.language);
  })
  .catch(() => {
    // Overrides are an enhancement layer — silently keep bundled defaults if unreachable.
  });

export default i18n;
